import { MenuItemType, PageTypeSuffix } from '@/constants'
import { type Menu } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import 'react-loading-skeleton/dist/skeleton.css'
import type { Settings } from 'react-slick'
import Slider from 'react-slick'
import ImageOptimize from '../ImageOptimize'
interface QuickMenuProps {
  QuickMenuData: Menu[]
}

const QuickMenuHome = ({ QuickMenuData }: QuickMenuProps) => {
  const settings: Settings = {
    dots: true,
    infinite: false,
    speed: 500,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    rows: 2,
    centerPadding: '5px',
  }
  // const settingsOneRow: Settings = {
  //   dots: true,
  //   infinite: false,
  //   speed: 500,
  //   arrows: false,
  //   slidesToShow: 5,
  //   slidesToScroll: 5,
  //   centerPadding: '5px',
  // }
  const data = QuickMenuData?.sort((a, b) => a.order - b.order)
  return (
    <>
      {data ? (
        <div className={` mb-4 rounded-xl bg-white py-2`} id='menuBoxScroll'>
          {data?.length <= 5 && (
            <div className='grid grid-cols-6 gap-3 px-2'>
              {data.map((item, index) => {
                return (
                  <Link
                    href={
                      item.type === MenuItemType.PRODUCT_CAT
                        ? `/${item.slug + PageTypeSuffix.CATEGORY}`
                        : item.url || '/'
                    }
                    key={index}
                    className='flex flex-col justify-center outline-none'
                  >
                    <ImageOptimize
                      src={item.icon}
                      alt={getTranslate(item.name)}
                      width={100}
                      height={100}
                      className='mx-auto aspect-square object-contain'
                    />

                    <span className='mt-1 line-clamp-2 block  overflow-hidden text-ellipsis whitespace-nowrap text-center text-base text-dark-400'>
                      {getTranslate(item.name)}
                    </span>
                  </Link>
                )
              })}
            </div>
          )}
          {data.length > 5 && data.length <= 10 && (
            <div className='grid grid-cols-6 gap-1.5'>
              {data.map((item, index) => {
                return (
                  <Link
                    href={
                      item.type === MenuItemType.PRODUCT_CAT
                        ? `/${item.slug + PageTypeSuffix.CATEGORY}`
                        : item.url || '/'
                    }
                    key={index}
                    className='!flex flex-col items-center justify-center outline-none'
                  >
                    <ImageOptimize
                      src={item.icon}
                      alt={getTranslate(item.name)}
                      width={80}
                      height={80}
                      className='mb-1 aspect-square object-contain'
                    />

                    <span className='text-textSmall line-clamp-2 block h-[28px] overflow-hidden text-ellipsis text-center text-dark-400'>
                      {getTranslate(item.name)}
                    </span>
                  </Link>
                )
              })}
            </div>
          )}
          {data.length > 10 && (
            <Slider {...settings} className='slickCate slickHome'>
              {data.map((item, index) => {
                return (
                  <Link
                    href={
                      item.type === MenuItemType.PRODUCT_CAT
                        ? `/${item.slug + PageTypeSuffix.CATEGORY}`
                        : item.url || '/'
                    }
                    key={index}
                    className='mb-1 mr-1 !flex flex-wrap justify-center pr-1 outline-none'
                  >
                    <ImageOptimize
                      src={item.icon}
                      alt={getTranslate(item.name)}
                      width={80}
                      height={80}
                      className='aspect-square object-contain'
                    />

                    <span className='text-textSmall line-clamp-2 block h-[28px] overflow-hidden text-ellipsis text-center font-bold  text-dark-400'>
                      {getTranslate(item.name)}
                    </span>
                  </Link>
                )
              })}
            </Slider>
          )}
        </div>
      ) : (
        ''
      )}
    </>
  )
}
export default QuickMenuHome
